import React from "react";
import SalesOrdersPageGen from "./generated/SalesOrdersPageGen";
import salesOrdersService from "../../../services/legacy/salesOrdersService";
import DeliveryAddressPickerButton from "../../../components/legacy/DeliveryAddressPickerModal";

// Grid aligned to AX SalesTable > TabHeaderOverview > GridHeader.
// If some AX controls are not mapped in IDAX metadata yet, they are simply ignored.
const SHOW_IN_GRID = new Set([
  "confirmed",
  "cmtsalespackingstatus",
  "salesid",
  "purchorderformnum",
  "custaccount",
  "invoiceaccount",
  "salestype",
  "salesstatus",
  "currencycode",
  "isalesidblanket",
  "admiteempalmes",
  "customerdeposito",
  "manufacturedorderid",
  "createdby",
]);

const SHOW_IN_FILTER = new Set([
  "salesid",
  "purchorderformnum",
  "custaccount",
  "invoiceaccount",
  "salesstatus",
]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    table: column.table || "SalesTable",
    tableLabel: column.tableLabel || "SalesTable",
    showInGrid: column.sourceJoin ? column.showInGrid : SHOW_IN_GRID.has(String(column.key || "").toLowerCase()),
    showInFilter: column.sourceJoin ? column.showInFilter : SHOW_IN_FILTER.has(String(column.key || "").toLowerCase()),
    showInForm: column.key === "iSalesId" ? false : column.showInForm,
    ...(String(column.key || "").toLowerCase() === "custaccount"
      ? { lookupFixedFilters: { inactive: 0 } }
      : {}),
  }));
};

const SalesOrdersPage = () => {
  const service = salesOrdersService;
  return (
    <SalesOrdersPageGen
      service={service}
      transformColumns={transformColumns}
      crudConfigOverride={{
        initialSort: {
          key: "modifieddate",
          backendKey: "modifieddate",
          direction: "descending",
        },
        renderForm: ({ formData, onChange, renderDefaultForm }) => (
          <>
            <DeliveryAddressPickerButton
              custAccount={formData.custaccount}
              onSelect={(addressFields) =>
                onChange({ ...formData, ...addressFields })
              }
            />
            {renderDefaultForm()}
          </>
        ),
      }}
    />
  );
};

export default SalesOrdersPage;
